export const Customer_getCustomerLazy = () =>
  import("./customer.grpc").then((m) => m.Customer_getCustomer);
Customer_getCustomerLazy.method = "Customer.Customer/getCustomer" as const;

export const Customer_hasValidTokenLazy = () =>
  import("./customer.grpc").then((m) => m.Customer_hasValidToken);
Customer_hasValidTokenLazy.method = "Customer.Customer/hasValidToken" as const;
